<template>
    <div ref="container" class="container rounded-xl" @click.stop="onClick">
        <div v-for="(shot, index) in shots" :key="index" :style="getShotStyle(shot)">
            <div v-if="shot.throwStatus !== 'made'">
                <v-icon color="red" size="24">mdi-close-thick</v-icon>
                <v-icon class="mx-0 px-0" color="white" size="30">{{ `mdi-numeric-${shot.pointsType === '3pts' ? '3' : '2'}-box` }}</v-icon>
            </div>
            <div v-else>
                <v-icon color="green" size="24">mdi-check-bold</v-icon>
                <v-icon class="mx-0 px-0" color="white" size="30">{{ `mdi-numeric-${shot.pointsType === '3pts' ? '3' : '2'}-box` }}</v-icon>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ShootingChart',
        props: {
            made: {
                type: Boolean,
                default: null
            },
            // basket: position of the hoop as fractions of container width/height (0..1)
            basket: {
                type: Object,
                default: () => ({ x: 0.5, y: 0 })
            },
            // threePointRadius: radius (fraction of container width) that defines 3pt distance
            threePointRadius: {
                type: Number,
                default: 0.43
            },
            shootingId: {
                type: String,
                required: true
            }
        },
        data: () => ({
            shots: []
        }),
        created() {
            this.shots = []
        },
        watch: {
            shootingId() {
                console.log('reset shots for id', this.shootingId)
                this.shots = []
            }
        },
        methods: {
            onClick(e) {
                if (this.shots.length >= 1) this.shots = [] // Limit to 10 shots for demo
                const rect = this.$refs.container.getBoundingClientRect()
                const iconSize = 24
                // Get click position relative to container, center icon
                const x = e.clientX - rect.left - iconSize / 2
                const y = e.clientY - rect.top - iconSize / 2
                // Store as percentage
                const xPercent = x / rect.width
                const yPercent = y / rect.height
                // determine whether shot is 2pts or 3pts based on distance to basket
                // use normalized coordinates (fractions) so aspect/size doesn't affect the result
                const shotCenterXPercent = (x + iconSize / 2) / rect.width
                const shotCenterYPercent = (y + iconSize / 2) / rect.height
                const dx = shotCenterXPercent - this.basket.x
                const dy = shotCenterYPercent - this.basket.y
                const distanceNorm = Math.sqrt(dx * dx + dy * dy)
                const pointsType = distanceNorm > this.threePointRadius ? '3pts' : '2pts'
                this.$emit('setCategory', pointsType)
                this.shots.push({ x: xPercent, y: yPercent, throwStatus: this.made ? 'made' : 'missed', pointsType })
                this.$emit('updateShots', this.shots)
            },
            removeShot(index) {
                this.shots.splice(index, 1)
                this.$emit('updateShots', this.shots)
            },
            getShotStyle(shot) {
                // Get current container size
                const container = this.$refs.container
                let width = 350
                let height = 350
                if (container) {
                    const rect = container.getBoundingClientRect()
                    width = rect.width
                    height = rect.height
                }
                // Convert percent to px, center icon
                const left = shot.x * width
                const top = shot.y * height
                return {
                    position: 'absolute',
                    left: `${left}px`,
                    top: `${top}px`
                }
            }
        }
    }
</script>

<style lang="css" scoped>
    .container {
        position: relative;
        cursor: pointer;
        width: 550px;
        height: 550px;
        min-width: 550px;
        min-height: 550px;
        background: url('../assets/halfcourt.jpg'), #dddddf;
        background-size: contain;
        overflow: hidden;
    }
</style>
